import _ from "lodash";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
// import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import { evalExpression } from "../utils/parseUtils";
import { m } from "../utils/i18n";
import { getSiteParams } from "../configuration/wizardConfiguration";

const { summary_background_color } = getSiteParams();

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    background: summary_background_color,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export const SummaryCard = ({ formData, steps }) => {
  const classes = useStyles();

  const summaryItems = _.filter(
    steps.map(function (step, index) {
      switch (step.summaryItemType) {
        case "KEY":
          // if (!_.isEmpty(formData[step.summaryKeyName])) {
          //   setShowSummary(true);
          // }
          return formData[step.summaryKeyName] ? (
            <div key={step.summaryKeyName}>
              <Typography variant="body2" component="p">
                {formData[step.summaryKeyName]}
              </Typography>
              <Divider />
            </div>
          ) : null;
        case "KEYPRICE":
          // if (!_.isEmpty(formData[step.summaryKeyName])) {
          //   setShowSummary(true);
          // }
          const codeKey = `${step.summaryKeyName}___code`;
          const priceKey = `${step.summaryKeyName}___price`;
          return formData[step.summaryKeyName] ? (
            <div key={step.summaryKeyName}>
              <Typography variant="body2" component="p">
                {formData[codeKey]} - {formData[step.summaryKeyName]} (
                {formData[priceKey]})
              </Typography>
              <Divider />
            </div>
          ) : null;
        case "MULTICOLUMN":
          return formData[step.summaryKeyName] ? (
            <div key={step.summaryKeyName}>
              <Typography variant="body2" component="p">
                {formData[step.summaryKeyName]}
              </Typography>
              <Divider />
            </div>
          ) : null;

        case "MULTIINPUT":
          return (
            <div key={step.summaryKeyName}>
              {step.params.fields.map((field) => {
                // formData[step.summaryKeyName]
                return !_.isEmpty(formData[field.name]) ? (
                  <div key={field.name}>
                    <Typography variant="body2" component="p">
                      {field.label}:{" "}
                      {field.type === "text" ? formData[field.name] : ""}
                      {field.type === "list"
                        ? _.find(field.options, { value: formData[field.name] })
                            .label
                        : ""}
                    </Typography>
                    <Divider />
                  </div>
                ) : (
                  ""
                );
              })}
            </div>
          );

        case "DYNAMICGRID":
          return (
            <div key={step.summaryKeyName}>
              <Typography variant="body2" component="p">
                {step.params.radioGroup.label}
                {formData[step.params.radioGroup.name].map(
                  (field, fieldidx) => {
                    return (
                      <div key={fieldidx}>
                        - {field[0]} {step.params.rowText1} {field[1]}{" "}
                        {step.params.rowText2}
                      </div>
                    );
                    // formData[step.summaryKeyName]
                    // return !_.isEmpty(formData[field.name]) ? (
                    //   <div key={field.name}>
                    //     <Typography variant="body2" component="p">
                    //       {field.label}:{" "}
                    //       {field.type === "text" ? formData[field.name] : ""}
                    //       {field.type === "list"
                    //         ? _.find(field.options, { value: formData[field.name] })
                    //             .label
                    //         : ""}
                    //     </Typography>
                    //     <Divider />
                    //   </div>
                    // ) : (
                    //   ""
                    // );
                  }
                )}
              </Typography>
            </div>
          );

        case "GROUPED":
          let groups = _.uniqBy(step.params.radioGroupCollection, "name");

          let options = [];
          _.forEach(groups, function (group) {
            let item = { ...group };

            const pref = item.value.split("{{NNN}}")[0];
            const groupLabel = item.label.split("{{NNN}}")[0];

            // all Items in formData for this group
            const keysForGroup = Object.keys(formData).filter(function (
              formDataKey
            ) {
              return formDataKey.indexOf(pref) === 0;
            });
            const itemsForGroup = _.pick(formData, keysForGroup);

            let groupOptions = item.options.map((option) => {
              let opt = { ...option };
              opt.quantity = 0;
              opt.groupLabel = groupLabel;

              // conto quanti per questa option e incremento la quantità...
              _.forIn(itemsForGroup, function (value, key) {
                if (value === option.value) {
                  opt.quantity++;
                }
              });

              return opt.quantity > 0 ? opt : "";
            });

            options = _.concat(options, groupOptions);
          });

          // filter
          options = _.filter(options, function (o) {
            return !_.isEmpty(o);
          });

          const { visibleIf, quantity, text } = step.params.summaryAddendum;
          const show = evalExpression(visibleIf, formData);
          if (show) {
            options.push({
              quantity: evalExpression(quantity, formData),
              groupLabel: text,
              value: "",
            });
            // addendum = `Nr. ${evalExpression(quantity)} ${text}`;
          }

          return !_.isEmpty(options) ? (
            <div>
              {options.map(function (opt, index) {
                let childKey = `${opt.groupLabel}${opt.value}`;
                return (
                  <div key={childKey}>
                    <Typography variant="body2" component="p">
                      Nr. {opt.quantity} {opt.groupLabel} {opt.value}
                    </Typography>
                    <Divider />
                  </div>
                );
              })}
            </div>
          ) : null;

        case "QUANTITY":
          return formData[step.params.radioGroup.quantityValue] > 0 ? (
            <div key={step.id}>
              <Typography variant="body2" component="p">
                {`Nr. ${formData[step.params.radioGroup.quantityValue]} ${
                  step.params.radioGroup.label
                }`}
              </Typography>
              <Divider />
            </div>
          ) : null;
        case "KEY_AND_QUANTITY":
          // if (!_.isEmpty(formData[step.summaryKeyName])) {
          //   setShowSummary(true);
          // }


          const key = step.summaryKeyName;
          const toShow = _.filter(_.keys(formData),function(param) {
                return _.startsWith(param, `${key}_`) && _.endsWith(param, '___qty');
              } )
    
          

          // const label = formData[step.summaryKeyName];
          // const qty_key = `${step.summaryKeyName}_${formData[`${step.summaryKeyName}___code`]}___qty`;
          // const qty = formData[qty_key];
          return toShow.map((qty_key) => {
            const label_key = qty_key.replace("___qty","___label");
            const qty = formData[qty_key];
            const label = formData[label_key];
            return ( (qty>0)?
              <div key={qty_key}>
                <Typography variant="body2" component="p">
                  {/* {`Nr. ${formData[step.params.radioGroup.quantityValue]} ${ */}
                  {`Nr. ${qty}  ${label}`}                
                </Typography>
                <Divider />
              </div>
              : <></>

            )
          });
          
        
          // return formData[step.summaryKeyName] ? (
          //   <div key={step.summaryKeyName}>
          //     <Typography variant="body2" component="p">
          //       {/* {`Nr. ${formData[step.params.radioGroup.quantityValue]} ${ */}
          //       {`Nr. ${qty}  ${label}`}                

          //     </Typography>
          //     <Divider />
          //   </div>
          // ) : null;
        case "QUANTITY_AND_KEY":
          const item1 =
            formData[step.params.radioGroup.quantityValue] > 0 ? (
              <div key={step.id}>
                <Typography variant="body2" component="p">
                  {`Nr. ${formData[step.params.radioGroup.quantityValue]} ${
                    step.params.radioGroup.label
                  }`}
                </Typography>
                <Divider />
              </div>
            ) : null;

          const item2 = formData[step.optionSummaryKeyName] ? (
            <div key={step.optionSummaryKeyName}>
              <Typography variant="body2" component="p">
                {formData[step.optionSummaryKeyName]}
              </Typography>
              <Divider />
            </div>
          ) : null;

          // let res = [item1, item2].join("");

          // return res !== "" ? res : null;
          // return [item2];
          return [item1, item2];

        default:
          return null;
      }
    }),
    function (o) {
      return !_.isEmpty(o);
    }
  );

  return summaryItems.length > 0 ? (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Box align="center">
          <Typography variant="subtitle1" component="p">
            <b>{m("common.summary")}</b>
          </Typography>
        </Box>

        <Divider />
        {summaryItems}
      </CardContent>
    </Card>
  ) : (
    <></>
  );
};

//   return (
//     <Card className={classes.root} variant="outlined">
//       <CardContent>
//         {steps.map(function (step, index) {
//           return toShow(step) ? (
//             step.groupedInSummary ? (
//               <div>
//                 {step.params.radioGroupCollection.map((group, index) => {
//                   let item = { ...group };

//                   const pref = item.value.split("{{NNN}}")[0];
//                   const groupLabel = item.label.split("{{NNN}}")[0];

//                   // all Items in formData for this group
//                   const keysForGroup = Object.keys(formData).filter(function (
//                     formDataKey
//                   ) {
//                     return formDataKey.indexOf(pref) === 0;
//                   });
//                   const itemsForGroup = _.pick(formData, keysForGroup);

//                   return item.options.map((option) => {
//                     let opt = { ...option };
//                     opt.quantity = 0;

//                     // conto quanti per questa option e incremento la quantità... que filtro va fuori da option
//                     _.forIn(itemsForGroup, function (value, key) {
//                       if (value === option.value) {
//                         opt.quantity++;
//                       }
//                     });

//                     return opt.quantity > 0 ? (
//                       <div key={step.summaryKeyName}>
//                         <Typography variant="body2" component="p">
//                           Nr. {opt.quantity} {groupLabel} {opt.value}
//                         </Typography>
//                         <Divider />
//                       </div>
//                     ) : (
//                       ""
//                     );
//                   });
//                 })}
//               </div>
//             ) : (
//               <div key={step.summaryKeyName}>
//                 <Typography variant="body2" component="p">
//                   {formData[step.summaryKeyName]}
//                 </Typography>
//                 <Divider />
//               </div>
//             )
//           ) : (
//             ""
//           );
//         })}
//       </CardContent>

//     </Card>
//   );
// };

/*


/*
        <List component="nav" aria-label="Summary">
          {Object.keys(formData).map(function (key, index) {
            return formData[key] === "" ? (
              ""
            ) : (
              <>
                <ListItem button>
                  <ListItemText primary={formData[key]} />
                </ListItem>
                <Divider />
              </>
            );
          })}
        </List>


*/
